<script lang="ts">
	import type { Device } from 'src/types/Device';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';
	import type { DeviceSettingsG2 } from 'src/types/DeviceSettings';
	import CameraVideoPlayer from '../CameraPlayer/CameraVideoPlayer.svelte';
	import LastRecordings from './LastRecordings.svelte';
	import RecordingKeyPrompt from '../CameraPlayer/RecordingKeyPrompt.svelte';
	import RecordingSetupPrompt from '../CameraPlayer/RecordingSetupPrompt.svelte';
	import CameraCloudStoragePromoBanner from 'src/components/Settings/CameraCloudStorage/CameraCloudStoragePromoBanner.svelte';
	import { ensureDeviceEncryption } from '../helpers/recording-key-management';

	export let device: Device, statuses, status: DeviceStatusG2, settings: DeviceSettingsG2;

	// On open: resolve the device key up-front (so recent recordings and thumbnails
	// decrypt without a mid-stream stop), else start the setup flow or password
	// prompt. No-op on firmware without encryption support.
	$: if (device?.id) ensureDeviceEncryption(device);
</script>

<div class="flex-full-height flex-column gap-m">
	<CameraVideoPlayer {device} {status} {settings} />
	<LastRecordings deviceId={device.id} />
	<CameraCloudStoragePromoBanner deviceId={device?.id} />
</div>

<RecordingKeyPrompt />
<RecordingSetupPrompt {device} />
